import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackAddUserToWishListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/wishList/trackAddUserToWishList";

const useTrackAddUserToWishList = (
    parameters: TrackAddUserToWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.addUserToWishList, parameters, options);
};

export default useTrackAddUserToWishList;
